import { Component, Property } from '@wonderlandengine/api';

/**
 * Wrapper for teleport component that only enables it in VR mode
 * This prevents errors when running in desktop/browser mode
 */
export class VrTeleportWrapper extends Component {
    static TypeName = 'vr-teleport-wrapper';
    static Properties = {
        teleportComponent: Property.object()
    };
    
    init() {
        this.isVrMode = false;
        this.teleportComp = null;
    }
    
    start() {
        // Get the teleport component
        if (this.teleportComponent) {
            this.teleportComp = this.teleportComponent.getComponent('teleport');
            if (!this.teleportComp) {
                console.warn('[VrTeleportWrapper] No teleport component found on specified object');
                return;
            }
        } else {
            // Try to get it from the same object
            this.teleportComp = this.object.getComponent('teleport');
        }
        
        if (this.teleportComp) {
            // Initially disable teleport until VR is entered
            this.teleportComp.active = false;
            console.log('[VrTeleportWrapper] Teleport component found and disabled for desktop mode');
        }
        
        // Listen for VR session changes
        this.onXRSessionStart = () => {
            console.log('[VrTeleportWrapper] VR session started - enabling teleport');
            this.isVrMode = true;
            if (this.teleportComp) {
                this.teleportComp.active = true;
            }
        };
        
        this.onXRSessionEnd = () => {
            console.log('[VrTeleportWrapper] VR session ended - disabling teleport');
            this.isVrMode = false;
            if (this.teleportComp) {
                this.teleportComp.active = false;
            }
        };
        
        // Register XR session listeners
        if (this.engine.xr) {
            this.engine.onXRSessionStart.add(this.onXRSessionStart);
            this.engine.onXRSessionEnd.add(this.onXRSessionEnd);
        }
    }
    
    onDestroy() {
        // Clean up listeners
        if (this.engine.xr) {
            this.engine.onXRSessionStart.remove(this.onXRSessionStart);
            this.engine.onXRSessionEnd.remove(this.onXRSessionEnd);
        }
    }
}